import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const homeGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.getCurrentUser();
  if (!user) {
    router.navigate(['/login']);
    return false;
  }

  const role = user.role;

  if (role === 'USER' || role === 'SUB_USER') {
    router.navigate(['/booking']);
  } else {
    // SUPER_ADMIN, ORG_ADMIN
    router.navigate(['/dashboard']);
  }

  return false;
};
